import axios, { Method } from "axios";

interface RequestOption {
  url: string;
  data?: any;
  method?: Method;
  params?: any;
  ignore?: boolean;
  message?: string;
}
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default <T>(obj: RequestOption): Promise<T> => {
  const token = localStorage.getItem("token");
  return new Promise((resolve, reject) => {
    axios({
      url: obj.url,
      baseURL: process.env.REACT_APP_API_URL, // eslint-disable-line
      method: obj.method ? obj.method : "GET",
      params: obj.params,
      headers: {
        authorization: token,
        "Content-Type": "application/json",
      },
      data: obj.data,
      transformRequest: [
        (data: unknown) => {
          return JSON.stringify(data, (k, v) => (v === undefined ? null : v));
        },
      ],
      timeout: 60000,
    })
      .then((response) => {
        if (obj.message) {
          window.webApp.showMessage("success", obj.message);
        }
        resolve(response.data as T);
      })
      .catch((err: any) => {
        console.error("err", err);
        var msg = "";
        if (err.response) {
          msg = err.response.data.message || err.response.data;
        } else {
          msg = "Requests failed because of network issue. Please try again";
        }
        if (!obj.ignore) {
          if (err.response?.status === 403 && obj.url === "/authorize") {
            sessionStorage.setItem("error", msg);
          }
          if (token || obj.url === "/login") {
            window.webApp.showMessage(
              "error",
              typeof msg === "string" ? msg : err.message,
            );
          }
        }
        reject(new Error(msg));
      })
      .catch(reject);
  });
};
